<div class="mobile-navigation">
  <div class="mobile-navigation-header">
    <button
      type="button"
      class="close-button"
      aria-label="Navigation schließen"
      (click)="closeNavigation.emit()"
    >
      <ui-icon faName="xmark" faStyle="light"></ui-icon>
    </button>
  </div>

  @if (items().length) {
    <nav class="navigation" aria-label="Hauptnavigation">
      @for (item of items(); track item) {
        @if (item.url) {
          <a
            class="navigation-item"
            [class.navigation-item-active]="isActive(item.url)"
            uiNavLink
            [link]="item"
            (click)="closeNavigation.emit()"
          >
            <span class="navigation-item-label">{{ item.label }}</span>
          </a>
        } @else {
          <span class="navigation-item">
          <span class="navigation-item-label">{{ item.label }}</span>
        </span>
        }
      }
    </nav>
  }
</div>
